import { createStore, type Store, type StoreActionApi } from 'react-sweet-state';

import { type DocNode } from '@atlaskit/adf-schema';

import type { State } from './State';

export const store: Store<
	State,
	{
		openModal: (data: string | DocNode) => ({ setState }: StoreActionApi<State>) => void;
		closeModal: () => ({ setState }: StoreActionApi<State>) => void;
	}
> = createStore({
	name: 'dataSculptorModal',
	initialState: {
		isOpen: false,
		data: null,
	} as State,
	actions: {
		openModal:
			(data: string | DocNode): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({
					isOpen: true,
					data,
				});
			},
		closeModal:
			(): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({
					isOpen: false,
					data: null,
				});
			},
	},
});
